export default function StrengthIcon(props) {
  return (
    <svg
      {...props}
      width='26px'
      height='28px'
      viewBox='0 0 26 28'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g
        id='Page-1'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <g
          id='icon'
          transform='translate(1.666990, 1.250000)'
          stroke='#3D7BF3'
          strokeWidth='2'
        >
          <polygon
            id='Path'
            points='12.75001 0 12.75001 9.9167 22.66671 9.9167 9.91671 25.5 9.91671 15.5833 0 15.5833'
          ></polygon>
        </g>
      </g>
    </svg>
  )
}
